export default {
  stringTooShort: ({label}) => `${label} is too short`,
  notInSchema: ({label}) => `${label} is not in the schema`,
  required: ({label}) => `${label} is required`,
  unknownFieldType: ({label}) => `${label} is an unkown field type`,
  notAnArray: ({label}) => `${label} is not an array`,
  notAnObject: ({label}) => `${label} is not an object`,
  notAString: ({label}) => `${label} is not a string`,
  notADate: ({label}) => `${label} is not a date`,
  notAnInteger: ({label}) => `${label} is not an integer`,
  notANumber: ({label}) => `${label} is not a number`,
  notAnId: ({label}) => `${label} is not a valid ID`,
  stringTooLong: ({label}) => `${label} is too long`,
  numberTooSmall: ({label}) => `${label} is too small`,
  numberTooBig: ({label}) => `${label} is too big`,
  notABoolean: ({label}) => `${label} is not a boolean`,
  notAnEmail: ({label}) => `${label} is not an email`,
  notUnique: ({label}) => `${label} is not unique`,
  notFound: ({label}) => `${label} not found`,
  notAnAllowedValue: ({label}) => `${label} Not an allowed value`,
  invalid: ({label}) => `${label} is not a valid value`,
  mustStartWithPlus: 'The phone must start with +',
  emailExists: 'You already have an account',
  incorrectPassword: 'Incorrect password',
  noPassword:
    'Your account doesn\'t have a password, please go to "forgot password" to create a new one',
  userNotFound: 'You do not have an account here',
  invalidPhoneLength: 'The length of the phone number is incorrect',
  invalidRut: 'The Rut is invalid',
  invalidRUCEC: 'The RUC is invalid',
  invalidCICR: 'Invalid Cédula de identidad',
  invalidDIMEXCR: 'Invalid DIMEX',
  invalidCPSRCR: 'Invalid cédula provisional solicitud de refugio',
  invalidIBANCR: 'Invalid IBAN for an account in Costa Rica',
  invalidCedulaCo: 'Invalid national ID',
  invalidCedulaExtCo: 'Invalid national ID',
  invalidPasaporteCo: 'Invalid passport number',
}
